import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props, state) {
  var isBodyHigherThanContainer = state.itemCardBodyHeight > 48;
  return {
    cardWrapper: {
      padding: componentTheme.cardWrapperPadding
    },
    itemCardInnerContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: '24px',
      rowGap: '32px'
    },
    metricsContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      rowGap: '24px'
    },
    hiddenWhenNotExpanded: _objectSpread({
      display: 'block'
    }, !state.metricsExpanded && {
      display: 'none'
    }),
    blankSpace: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: componentTheme.blankHeight,
      minWidth: componentTheme.blankMinWidth,
      verticalAlign: 'middle',
      border: "1px solid ".concat(componentTheme.blankBorderColor),
      borderRadius: componentTheme.blankBorderRadius,
      padding: '2px 2px'
    },
    itemCardToggleButtonWrapper: {
      position: 'absolute',
      top: '0',
      right: componentTheme.viewPaddingRight
    },
    metricNumberContext: {
      fontSize: componentTheme.metricNumberContextFontSize,
      fontWeight: componentTheme.metricNumberContextFontWeight
    },
    itemBodyToggleButtonWrapper: {
      marginTop: '-8px'
    },
    itemBody: _objectSpread({
      minHeight: '48px'
    }, isBodyHigherThanContainer && !state.bodyExpanded && {
      position: 'relative',
      ':after': {
        left: '0',
        top: '0',
        content: '""',
        height: '48px',
        width: '100%',
        position: 'absolute',
        background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff)'
      }
    }),
    answerFrequencySummaryContainer: {
      width: 'calc(25% + 350px)',
      maxWidth: '100%'
    }
  };
};
export default generateStyle;